import React from 'react';
import { SvgIcon, useTheme } from '@mui/material';
import { INSURANCE_TYPE_DENTOLO, INSURANCE_TYPE_PETOLO, INSURANCE_TYPE_VITOLO } from '../../shared';
import useInsuranceInfo from '../../hooks/useInsuranceInfo';

function DentoloIcon(props) {
  const theme = useTheme();

  return (
    <SvgIcon inheritViewBox {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <path
          d="M13.2632 0.158203C14.6893 0.158417 17.2563 1.29937 17.5415 4.72168C17.8267 8.14432 16.003 11.7908 15.2593 13.2783C14.4036 14.9896 12.9773 17.8418 11.8364 17.8418C10.6959 17.8416 10.4106 16.7012 10.1255 15.5605C9.84194 14.4264 9.84011 12.1653 8.9995 12.1387C8.15918 12.1658 8.15702 14.4265 7.87352 15.5605C7.58835 16.7012 7.30328 17.8418 6.16258 17.8418C5.02171 17.8417 3.59538 14.9896 2.73973 13.2783C1.99594 11.7907 0.173268 8.14425 0.458482 4.72168C0.743727 1.29909 3.31071 0.158203 4.7368 0.158203C6.15851 0.158354 7.29679 1.29108 8.9995 1.29785C10.7025 1.2912 11.8412 0.158203 13.2632 0.158203Z"
          fill={theme.palette.text.customerOverviewCard}
        />
      </svg>
    </SvgIcon>
  );
}

function PetoloIcon(props) {
  const theme = useTheme();

  return (
    <SvgIcon inheritViewBox {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
      >
        <path
          d="M4.10981 9.9786C4.81353 9.29684 4.55251 8.01006 3.52679 7.10453C2.50107 6.19896 1.09906 6.01755 0.395315 6.69934C-0.308434 7.3811 -0.0474194 8.66788 0.978317 9.57342C2.00404 10.479 3.40605 10.6604 4.10981 9.9786Z"
          fill={theme.palette.text.customerOverviewCard}
        />
        <path
          d="M17.7805 6.37515C18.2793 5.17094 17.8993 3.91687 16.9318 3.57413C15.9642 3.23136 14.7756 3.92972 14.2768 5.13393C13.778 6.33814 14.158 7.59221 15.1255 7.93498C16.093 8.27772 17.2817 7.57936 17.7805 6.37515Z"
          fill={theme.palette.text.customerOverviewCard}
        />
        <path
          d="M13.4534 2.78257C13.5757 1.33329 12.7199 0.0895475 11.542 0.00458543C10.3642 -0.0803798 9.31024 1.02561 9.18801 2.47488C9.06578 3.92414 9.92153 5.1679 11.0994 5.25287C12.2772 5.33781 13.3312 4.23183 13.4534 2.78257Z"
          fill={theme.palette.text.customerOverviewCard}
        />
        <path
          d="M6.77668 6.12973C7.7829 5.57831 7.94203 4.10659 7.13208 2.84253C6.32213 1.5785 4.84986 1.00081 3.84364 1.55224C2.83742 2.10367 2.67833 3.57536 3.48828 4.83943C4.29819 6.10346 5.7705 6.68115 6.77668 6.12973Z"
          fill={theme.palette.text.customerOverviewCard}
        />
        <path
          d="M14.7714 9.10735C13.7388 8.04668 12.4433 7.27876 11.0171 6.88187C10.3851 6.68376 9.71223 6.65461 9.06546 6.79729H9.04796C8.40778 6.94015 7.81693 7.25011 7.33556 7.69564C6.24225 8.65157 5.43458 9.89116 5.00186 11.2774C4.55517 12.5767 4.60718 13.9956 5.14772 15.2587C5.214 15.4091 5.30948 15.5448 5.42863 15.658C5.54774 15.7713 5.68816 15.8597 5.84174 15.9183C5.99529 15.9769 6.15896 16.0045 6.32325 15.9994C6.48754 15.9943 6.64916 15.9567 6.79883 15.8887C7.33851 15.6437 7.84025 15.3287 8.3741 15.075C9.01107 14.7477 9.66549 14.4556 10.3344 14.1999C10.4967 14.1425 10.6624 14.0948 10.8303 14.057C10.9978 14.0204 11.1673 13.9941 11.3379 13.9783C12.0581 13.9233 12.7807 13.9077 13.5025 13.9316C14.0859 13.9316 14.6956 14.0074 15.2907 13.9958C15.4532 13.9961 15.6141 13.9631 15.7633 13.8987C15.9125 13.8344 16.0469 13.7401 16.1582 13.6217C16.2695 13.5033 16.3553 13.3633 16.4104 13.2104C16.4653 13.0575 16.4884 12.895 16.478 12.7328C16.3707 11.3566 15.7638 10.0671 14.7714 9.10735Z"
          fill={theme.palette.text.customerOverviewCard}
        />
      </svg>
    </SvgIcon>
  );
}

function VitoloIcon(props) {
  const theme = useTheme();

  return (
    <SvgIcon inheritViewBox {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.8667 9.55364L10.098 18.75L2.32939 9.55364V9.5419C-0.950138 5.39474 1.09253 2.39865 3.31962 1.471C7.31418 0.0580095 9.97846 5.85872 10.098 6.47715C10.2176 5.85872 12.8819 0.0580095 16.8765 1.471C19.1035 2.39865 20.6946 5.85526 17.8742 9.5419V9.55364H17.8667Z"
          fill={theme.palette.text.customerOverviewCard}
          stroke={theme.palette.text.customerOverviewCard}
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}

export default function CustomerOverviewCardIcon() {
  const { type: insuranceType } = useInsuranceInfo();

  switch (insuranceType) {
    case INSURANCE_TYPE_DENTOLO:
      return <DentoloIcon />;
    case INSURANCE_TYPE_PETOLO:
      return <PetoloIcon />;
    case INSURANCE_TYPE_VITOLO:
      return <VitoloIcon />;
    default:
      return null;
  }
}
